export interface ProgrammeCurriculumCourseJSON {
  id: string
  title: string
  code?: string | null
  credits?: number | null
  isActive?: boolean | null
}

export interface ProgrammeCurriculumJSON {
  id: string
  programme_id?: string | null
  programmeId?: string | null
  course_id?: string | null
  courseId?: string | null
  year?: number | null
  semester?: number | null
  required?: boolean | null
  order?: number | null
  meta?: Record<string, unknown> | null
  created_at?: string | null
  updated_at?: string | null
  createdAt?: string | null
  updatedAt?: string | null
  course?: ProgrammeCurriculumCourseJSON | null
}

export class ProgrammeCurriculumModel {
  readonly id: string
  readonly programmeId: string
  readonly courseId: string
  readonly year?: number
  readonly semester?: number
  readonly required: boolean
  readonly order?: number
  readonly meta?: Record<string, unknown> | null
  readonly createdAt?: string
  readonly updatedAt?: string
  readonly course?: ProgrammeCurriculumCourseJSON | null

  constructor(options: {
    id: string
    programmeId: string
    courseId: string
    year?: number
    semester?: number
    required?: boolean
    order?: number
    meta?: Record<string, unknown> | null
    createdAt?: string
    updatedAt?: string
    course?: ProgrammeCurriculumCourseJSON | null
  }) {
    this.id = options.id
    this.programmeId = options.programmeId
    this.courseId = options.courseId
    this.year = options.year
    this.semester = options.semester
    this.required = options.required ?? false
    this.order = options.order
    this.meta = options.meta
    this.createdAt = options.createdAt
    this.updatedAt = options.updatedAt
    this.course = options.course ?? null
  }

  static fromJSON(json: ProgrammeCurriculumJSON): ProgrammeCurriculumModel {
    return new ProgrammeCurriculumModel({
      id: json.id,
      programmeId: json.programmeId ?? json.programme_id ?? '',
      courseId: json.courseId ?? json.course_id ?? '',
      year: json.year ?? undefined,
      semester: json.semester ?? undefined,
      required: json.required ?? false,
      order: json.order ?? undefined,
      meta: json.meta ?? null,
      createdAt: json.createdAt ?? json.created_at ?? undefined,
      updatedAt: json.updatedAt ?? json.updated_at ?? undefined,
      course: json.course ?? undefined,
    })
  }

  toJSON(): ProgrammeCurriculumJSON {
    return {
      id: this.id,
      programmeId: this.programmeId,
      courseId: this.courseId,
      year: this.year ?? null,
      semester: this.semester ?? null,
      required: this.required,
      order: this.order ?? null,
      meta: this.meta ?? null,
      createdAt: this.createdAt ?? null,
      updatedAt: this.updatedAt ?? null,
      course: this.course ?? null,
    }
  }
}
